import { Award } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const getAwardById: (
  fetchContext: FetchContext,
  awardId: number,
  accessToken?: string,
) => Promise<Award> = (fetchContext, awardId, accessToken) => fetch(`${fetchContext.baseUrl}/api/awards/${awardId}`,
  {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<Award>(fetchContext.errorStore, response, 'get award by id'));
